import { render } from "./ContractTemplatesPage.vue?vue&type=template&id=16d01d53&scoped=true"
import script from "./ContractTemplatesPage.vue?vue&type=script&lang=js"
export * from "./ContractTemplatesPage.vue?vue&type=script&lang=js"

import "./ContractTemplatesPage.vue?vue&type=style&index=0&id=16d01d53&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d01d53"]])

export default __exports__